"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseURL = "https://api.tidal.com/v1/tracks";
const atob = (str) => Buffer.from(str, "base64").toString("binary");
exports.default = (axios) => ({
    /**
     * Get track info using its ID.
     * You need to either provide a client_id or an access_token.
     * Optionally you can set a countryCode, defaults to US.
     */
    get: async ({ id, countryCode = "US", client_id, access_token }) => {
        let headers = { "x-tidal-token": client_id };
        if (!client_id)
            headers = { authorization: `Bearer ${access_token}` };
        if (!client_id && !access_token)
            throw new Error("You need to either provide a client_id or an access_token.");
        const { data } = await axios({
            baseURL,
            headers,
            url: `${id}`,
            params: {
                countryCode,
            },
            responseType: "json",
        });
        return data;
    },
    /**
     * Recommended way to get a streaming URL.
     * Provide the track ID and valid access_token
     */
    stream: async ({ id, access_token, audioquality = "HIGH", playbackmode = "STREAM", assetpresentation = "FULL", countryCode = "US", }) => {
        const response = await axios({
            baseURL,
            url: `${id}/playbackinfopostpaywall`,
            headers: { authorization: `Bearer ${access_token}` },
            params: {
                audioquality,
                playbackmode,
                assetpresentation,
                countryCode,
            },
            responseType: "json",
        });
        const data = response.data;
        /* istanbul ignore if */
        if (data.manifestMimeType === "application/dash+xml")
            throw new Error("application/dash+xml is not supported");
        return JSON.parse(atob(data.manifest));
    },
    /**
     * Get a track's contributors.
     * You need to either provide a client_id or an access_token.
     * Limit and Offset are optional and default to 50 and 0, respectively.
     * Optionally you can set a countryCode, defaults to US.
     */
    contributors: async ({ id, countryCode = "US", limit = 50, offset = 0, client_id, access_token, }) => {
        let headers = { "x-tidal-token": client_id };
        if (!client_id)
            headers = { authorization: `Bearer ${access_token}` };
        if (!client_id && !access_token)
            throw new Error("You need to either provide a client_id or an access_token.");
        const { data } = await axios({
            baseURL,
            url: `${id}/contributors`,
            params: {
                countryCode,
                limit,
                offset,
            },
            headers,
            responseType: "json",
        });
        return data;
    },
});
